<template>

    <div>
        <div class="importConfigBlock">
            <div class="leftBlock">
                <h2>Production Source</h2>
                <pd-sourceblock :data-obj="ProductionSourceMap" data-id="ProductionSourceMap" :clickFn="addSource"></pd-sourceblock>
            </div>
            <div class="rightBlock">
                <h2>Die and Tool Type Code</h2>
                <pd-dtcblock :data-obj="DieAndToolCodeMap" data-id="DieAndToolCodeMap" :clickFn="addDTC"></pd-dtcblock>
            </div>

        </div>

        <div class="buttonbar">
            <pd-button label="Save" :click="saveDeliveryAddresses"></pd-button>
        </div>
    </div>

</template>


<script>
    import {mapGetters, mapState} from 'vuex';
    import Button from "../components/button.vue";
    import DtcBlock from "../components/dtcinputblock.vue";
    import SourceBlock from "../components/sourceinputblock.vue";


    export default {
        name: 'importConfigs',
        props: {
            msg: String
        },
        components: {
            "pd-button": Button,
            "pd-dtcblock": DtcBlock,
            "pd-sourceblock":SourceBlock
        },
        computed: {
            ...mapState("importConfigStore", [
                "DieAndToolCodeMap","ProductionSourceMap"
            ]),
            ...mapGetters('importConfigStore', [
                "DieAndToolCodeMap","ProductionSourceMap"
            ])
        },
        methods: {
            addDTC(addressId) {
                this.$store.commit('importConfigStore/addCodeRow', addressId);
            },
            addSource(addressId) {
                this.$store.commit('importConfigStore/addSourceRow', addressId);
            },
            saveDeliveryAddresses(){
                this.$store.commit('importConfigStore/persist');
            }
        },
        created() {
            this.$store.commit('importConfigStore/loadFromDb');
        }
    }
</script>